import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

// Wizard progress: numbered steps over a bar filled through the active step. Display only.
@Component({
  selector: 'lib-stepper',
  templateUrl: './stepper.html',
  styleUrl: './stepper.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepperComponent {
  steps = input.required<string[]>();
  activeIndex = input<number>(0);

  progress = computed(() => `${((this.activeIndex() + 1) / this.steps().length) * 100}%`);
}
